<script setup lang="ts">
  defineProps({
    loading: { type: Boolean, required: false, default: true },
  });
</script>
<template>
  <template v-if="loading">
    <div class="data-loader">
      <SfSpinner primary large />
      <p>{{ $t('SHOP.COMMON.MESSAGE.DATA_LOADING') }}</p>
    </div>
  </template>
  <template v-else>
    <slot />
  </template>
</template>
<style lang="scss">
  :root {
    --sf-data-loader-padding: 1rem;
    --sf-data-loader-gap: 1rem;
  }

  .data-loader {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: var(--sf-data-loader-gap);
    width: 100%;
    padding: var(--sf-data-loader-padding);
  }
</style>
